"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardHomeDetailsMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class PropertyCardHomeDetailsMixin */
/** @method */
var PropertyCardHomeDetailsMixin = function PropertyCardHomeDetailsMixin() {
  return (0, _styledToken.default)({
    color: 'PropertyCard.data.pipeColor'
  }, function (_ref) {
    var color = _ref.color;
    return (0, _styledComponents.css)(["&:not(:last-child):after,span:not(:last-child):after{content:' | ';color:", ";}"], color);
  });
};
exports.PropertyCardHomeDetailsMixin = PropertyCardHomeDetailsMixin;